import { reprojectBbox } from "../../../MapStore2/web/client/utils/CoordinatesUtils";
import { Projection } from "../../common/types";
import { Bbox } from "../../rootState";
import { wfsBlobService } from "../../api/api-packages/wfs-blob-service/wfsBlobService.service";
import { defaultParams } from "../../api/api-packages/wfs-service/wfsService.adapter";
import EnvParamsRetriever from "../../common/util/EnvParamsRetriever";
import { getStore } from "../../../MapStore2/web/client/utils/StateUtils";

const getReprojected = (bbox?: Bbox) => reprojectBbox(bbox?.bounds, bbox!.crs, Projection.EPSG_4326);

const getParams = (outputFormat: string, typeName: string, bbox?: Bbox) => {
    return {
        ...defaultParams,
        typeName: typeName,
        ENV: encodeURIComponent(EnvParamsRetriever.getWorkspaceEnvParams(getStore().getState()).toRequestParams()),
        bbox: getReprojected(bbox) + "," + Projection.EPSG_4326,
        outputFormat: outputFormat,
    };
};

const generateGetFeatureFile = async (fileFormat: string, typeName: string, bbox?: Bbox) => {
    const response = await wfsBlobService(getParams(fileFormat, typeName, bbox));
    if (fileFormat.includes("json")) {
        saveFile(JSON.stringify(response), "json");
    }
    if (fileFormat.toLowerCase().includes("gml")) {
        saveFile(response as string, "xml");
    }
};

const saveFile = (file: string, format: string) => {
    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(
        new Blob([file], {
            type: "application/" + format,
        })
    );
    a.target = "_blank";
    a.download = "features";
    a.click();
    document.removeChild(a);
};

const redirectToDownloadFile = (gisServerURL: string, fileFormat: string, typeName: string, bbox?: Bbox) => {
    const params = getParams(fileFormat, typeName, bbox);
    const urlRequest = Object.keys(params)
        .map((key) => {
            return key + "=" + (params as any)[key];
        })
        .join("&");
    window.open(gisServerURL + "wfs?" + urlRequest, "_blank");
};

export const getFile = (selectedFormat: string, layers: string, bbox: Bbox, gisServerUrl: string) => {
    if (!selectedFormat.includes("select")) {
        selectedFormat.match(/gml|json/gi)
            ? generateGetFeatureFile(selectedFormat, layers, bbox!)
            : redirectToDownloadFile(gisServerUrl, selectedFormat, layers, bbox!);
    }
};
